import { getCompanyHubEditRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { EditPageOrBlogV2Route } from './EditPageOrBlogV2Route.tsx';

export const CompanyHubEditRoute = getCompanyHubEditRoute(EditPageOrBlogV2Route);
